module.exports = __webpack_public_path__ + "static/img/consult1.c04f3e6a.png";